import { createFeatureSelector, createSelector } from '@ngrx/store'
import { CouponDetailState, CouponState } from './coupon.state'
import { couponFeature } from './coupon.reducer' // or correct path
// Feature State
export const selectCouponState = createFeatureSelector<CouponState>('coupon')

// All Coupons
export const selectCoupons = createSelector(
  selectCouponState,
  (state: CouponState) => state.coupons
)

// Total Count
export const selectCouponTotalCount = createSelector(
  selectCouponState,
  (state: CouponState) => state.totalCount
)

// Analytics
export const selectCouponAnalytics = createSelector(
  selectCouponState,
  (state: CouponState) => state.analytics
)

// Loading
export const selectCouponLoading = createSelector(
  selectCouponState,
  (state: CouponState) => state.loading
)

// Error
export const selectCouponError = createSelector(
  selectCouponState,
  (state: CouponState) => state.error
)

// Coupon By Id
export const selectCouponById = (id: string) =>
  createSelector(selectCoupons, coupons => coupons.find(coupon => coupon.id === id))

export const selectCouponDetailState = createFeatureSelector<CouponDetailState>('couponDetail')

export const selectCouponDetail = createSelector(selectCouponDetailState, state => state.coupon)

export const selectCouponDetailLoading = createSelector(
  selectCouponDetailState,
  state => state.loading
)

export const selectCouponDetailError = createSelector(selectCouponDetailState, state => state.error)

export const selectCouponActiveCount = createSelector(selectCouponState, state => state.activeCount)

export const selectCouponInactiveCount = createSelector(
  selectCouponState,
  state => state.inactiveCount
)

export const selectCouponExpiredCount = createSelector(
  selectCouponState,
  state => state.expiredCount
)
